const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.666 6.66797H8.33268C7.41221 6.66797 6.66602 7.41416 6.66602 8.33464V16.668C6.66602 17.5884 7.41221 18.3346 8.33268 18.3346H16.666C17.5865 18.3346 18.3327 17.5884 18.3327 16.668V8.33464C18.3327 7.41416 17.5865 6.66797 16.666 6.66797Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.33268 13.3346C2.41602 13.3346 1.66602 12.5846 1.66602 11.668V3.33464C1.66602 2.41797 2.41602 1.66797 3.33268 1.66797H11.666C12.5827 1.66797 13.3327 2.41797 13.3327 3.33464",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.c47ddff40f44dabc710b42327692c04a.svg";
export { ForwardRef as ReactComponent };